import React from 'react';
import SelectField from 'components/pure/utils/form/SelectField';
import {List} from 'immutable';
import {CREATE_NEW, NONE} from 'components/pure/admin/QuestionForm.const';

const toOption = reason => ({
  label: reason.name,
  value: reason.id,
});

export default class ReasonsSelectField extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      reasonSchemes: List(),
    };
    this.onChange = this.onChange.bind(this);
  }

  onChange(values) {
    this.setState({
      searchTerm: '',
    });
    this.props.onChange(values);
  }

  render() {
    // the first option should be "create new"
    const optionsFromReasons = this.props.values ? this.props.values.map(toOption) : [];
    const options = optionsFromReasons
      .unshift({
        label: CREATE_NEW,
        value: CREATE_NEW,
      })
      .unshift({
        label: NONE,
        value: NONE,
      });

    return (
      <SelectField
        placeholder=""
        hideResetButton={true}
        tether={true}
        options={options}
        itemsHaveX={true}
        onChange={this.onChange}
        onOpenChange={this.props.onOpenChange}
        filterOptions={options => options}
        value={this.props.value}
      />
    );
  }
}
